/*
 * Osmérix — animation de l'eau sur l'image d'une bannière.
 * Repères en % de l'image : "x, haut, bas, épaisseur" (centre du filet, sortie du robinet,
 * surface de l'eau dans le verre, largeur du filet). Le calque suit le recadrage de l'image (object-fit: cover).
 */
(function () {
  if (window.OsmerixHeroWater) return;
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var BUBBLES = 6;

  function parseSpec(value) {
    var parts = String(value || '').split(',').map(parseFloat);
    if (parts.length < 3 || parts.slice(0, 3).some(isNaN)) return null;
    return { x: parts[0], top: parts[1], bottom: parts[2], width: isNaN(parts[3]) ? 0.8 : parts[3] };
  }

  function objectPosition(img) {
    var values = getComputedStyle(img).objectPosition.split(' ');
    return values.map(function (value) { return value.indexOf('%') > -1 ? parseFloat(value) / 100 : 0.5; });
  }

  function build(layer) {
    if (layer.childElementCount) return;
    var html = '<span class="hero__water-stream"></span>';
    for (var r = 0; r < 3; r++) html += '<span class="hero__water-ripple"></span>';
    for (var b = 0; b < BUBBLES; b++) html += '<span class="hero__water-bubble"></span>';
    layer.innerHTML = html;
  }

  function place(layer) {
    var media = layer.parentElement;
    var img = media && media.querySelector('img');
    if (!img || !img.naturalWidth) return;

    var mobile = mobileQuery.matches;
    var raw = layer.dataset.desktop;
    if (mobile && layer.dataset.mobileImage === 'true') raw = layer.dataset.mobile;
    var spec = parseSpec(raw);
    layer.hidden = !spec;
    if (!spec) return;

    var boxWidth = media.clientWidth;
    var boxHeight = media.clientHeight;
    var scale = Math.max(boxWidth / img.naturalWidth, boxHeight / img.naturalHeight);
    var width = img.naturalWidth * scale;
    var height = img.naturalHeight * scale;
    var position = objectPosition(img);

    layer.style.left = (boxWidth - width) * position[0] + 'px';
    layer.style.top = (boxHeight - height) * position[1] + 'px';
    layer.style.width = width + 'px';
    layer.style.height = height + 'px';

    var length = (spec.bottom - spec.top) / 100 * height;
    var glass = length * 0.8;
    layer.style.setProperty('--x', spec.x);
    layer.style.setProperty('--top', spec.top);
    layer.style.setProperty('--bottom', spec.bottom);
    layer.style.setProperty('--w', spec.width);
    layer.style.setProperty('--period', Math.max(12, length / 3) + 'px');
    layer.style.setProperty('--ripple', glass + 'px');

    var centerX = spec.x / 100 * width;
    var surfaceY = spec.bottom / 100 * height;
    var bubbles = layer.querySelectorAll('.hero__water-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var depth = glass * (0.25 + 0.7 * ((i * 0.37) % 1));
      var size = Math.max(2, Math.min(5, length / 30));
      var bubble = bubbles[i];
      bubble.style.left = centerX + glass * 0.38 * (((i * 0.61) % 1) * 2 - 1) + 'px';
      bubble.style.top = surfaceY + depth + 'px';
      bubble.style.setProperty('--rise', depth * 0.9 + 'px');
      bubble.style.setProperty('--size', size + 'px');
      bubble.style.animationDuration = 1.8 + (i % 3) * 0.6 + 's';
      bubble.style.animationDelay = i * 0.45 + 's';
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hero-water]').forEach(function (layer) {
      build(layer);
      var img = layer.parentElement.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () { place(layer); });
      place(layer);
    });
  }

  function refresh() {
    document.querySelectorAll('[data-hero-water]').forEach(place);
  }

  window.addEventListener('resize', refresh);
  if (mobileQuery.addEventListener) { mobileQuery.addEventListener('change', refresh); } else { mobileQuery.addListener(refresh); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  window.OsmerixHeroWater = { init: init, refresh: refresh };
})();
